import type { ApiResult } from '@/infra/api'
import { API_ENDPOINTS, httpPost } from '@/infra/api'
import type { OnboardingUpdateRequest } from '../types'

export const onboardingClient = {
  updateOnboarding(request: OnboardingUpdateRequest): Promise<ApiResult<void>> {
    return httpPost<void>(API_ENDPOINTS.USER_ONBOARD, request)
  },
}
